import React, { useCallback, useMemo } from 'react';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ru from 'date-fns/locale/ru';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import { getControlComponentAndPropsForField, renderErrors, useErrors } from './utils';

import './form-field.css';

registerLocale('ru', ru);

export function FormField(props) {
    const { field, formik, errors, onEditClick, onChange, readOnly, hideLabelOnBigScreen, ...otherProps } = props;
    const [ControlComponent, controlProps, name, type, label, showLabel, helpText] =
        getControlComponentAndPropsForField(field, formik, otherProps);

    const errMess = useErrors(name, formik, errors);

    const handleChange = useCallback(
        (e) => {
            if (formik) {
                if (['date', 'fonostart'].includes(type)) formik.setFieldValue(name, e || '');
                else formik.handleChange(e);
            }
            if (onChange) {
                if (['date', 'fonostart'].includes(type)) onChange(e || '', name);
                else onChange(e.currentTarget.value || '', name);
            }
        },
        [formik, type, name, onChange]
    );
    const handleEditClick = useCallback(
        (e) => {
            if (onEditClick) onEditClick(e, field);
        },
        [onEditClick, field]
    );

    const labelClasses = useMemo(() => {
        let result = 'small m-0 position-relative';
        if (hideLabelOnBigScreen) result += ' d-sm-none';
        return result;
    }, [hideLabelOnBigScreen]);

    return (
        <>
            {showLabel && (
                <Form.Label className={labelClasses}>
                    <span className="font-weight-bold">{label}</span>
                </Form.Label>
            )}
            {showLabel && helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
            <div className="position-relative">
                <ControlComponent
                    isInvalid={!!errMess}
                    readOnly={readOnly}
                    disabled={readOnly}
                    onChange={handleChange}
                    {...controlProps}
                />
                {type !== 'infotext' && onEditClick && readOnly && (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-edit-field-${name}`}>Изменить</Tooltip>}
                    >
                        <Button variant="link" size="sm" className="form-field__edit-btn" onClick={handleEditClick}>
                            <FontAwesomeIcon icon={faPen} size="1x" />
                        </Button>
                    </OverlayTrigger>
                )}

                {errMess && <Form.Control.Feedback type="invalid">{renderErrors(errMess)}</Form.Control.Feedback>}
            </div>
        </>
    );
}
